import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr2008',
    ecrans: ['00-2'],
    params: ['?rsscleint']
});
